import { gql } from '@apollo/client';
import Fragment from '../fragments/fragments';

export const USER_ADDITIONAL_DATA_UPDATED = gql`
  subscription userAdditionalDataUpdated {
    userAdditionalDataUpdated {
      ...userAdditionalData
    }
  }
  ${Fragment.userAdditionalData}
`;

export const USER_AGENDA_UPDATED = gql`
  subscription userAgendaUpdated {
    userAgendaUpdated {
      userAgendas {
        id
        userId
        email
        contactName
      }
    }
  }
`;
